/**
 * Browser-side mirror of the bounded Calls API search contract.
 *
 * These values remain local because the current shared packages do not expose
 * endpoint-specific validation constants.
 */
export const CALL_SEARCH_MIN_LENGTH = 3;

/** Maximum normalized call-search length accepted by the API. */
export const CALL_SEARCH_MAX_LENGTH = 100;

/** Maximum whitespace-delimited words accepted by the API. */
export const CALL_SEARCH_MAX_WORDS = 5;
